import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import {
  FaFacebook,
  FaInstagram,
  FaWhatsapp,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
} from 'react-icons/fa';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './LandingPage.css';

import fotocandidato from './assets/candidato.png';
import logo from './assets/logo.png';
import fotoaerea from './assets/alcobaca.jpg';

const LandingPage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [marianaLink, setMarianaLink] = useState('');

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);

    fetch('/data.json')
      .then((response) => response.json())
      .then((data) => {
        setMarianaLink(data.mariana_llm);
      })
      .catch((error) => {
        console.error('Error fetching data.json:', error);
      });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const testimonials = [
    {
      name: 'Maria Santos',
      role: 'Empresária Local',
      image:
        'https://images.unsplash.com/photo-1527203561188-dae1bc1a417f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxwb3J0cmFpdHxlbnwwfHx8b3JhbmdlfDE3NTI3MDU0NjJ8MA&ixlib=rb-4.1.0&q=85',
      content:
        'Calha bem, que ando a usar o meu marido para fazer formas de gesso, para ovos moles aahahah entendeu a graça?.',
    },
    {
      name: 'António Silva',
      role: 'Presidente de Junta',
      image:
        'https://images.unsplash.com/photo-1652477633088-da74a0225dfc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxwb3J0cmFpdHxlbnwwfHx8b3JhbmdlfDE3NTI3MDU0NjJ8MA&ixlib=rb-4.1.0&q=85',
      content:
        'Trabalhei com a Hermione em vários projetos para a nossa região. Mas desde que perdeu a varinha que ela não é a mesma.',
    },
    {
      name: 'Ana Rodrigues',
      role: 'Professora',
      image:
        'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHN8ZW58MHx8fHwxNzUyNzA2NDgzfDA&ixlib=rb-4.1.0&q=85',
      content:
        'Como educadora, valorizo muito o compromisso da hermione com a educação e o desenvolvimento das nossas crianças muggles.',
    },
    {
      name: 'Carlos Mendes',
      role: 'Comerciante',
      image:
        'https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHN8ZW58MHx8fHwxNzUyNzA2NDgzfDA&ixlib=rb-4.1.0&q=85',
      content:
        'A Hermione entende faz truques de desaparecer, um pouco como os políticos locais.',
    },
    {
      name: 'Teresa Costa',
      role: 'Enfermeira',
      image:
        'https://images.pexels.com/photos/1367269/pexels-photo-1367269.jpeg',
      content:
        'Na área da saúde, a Hermione tem mostrado um grande interesse em melhorar os serviços para a população. Está até a pensar nos próximos 4 anos tirar medicina por correspondência. ',
    },
  ];

  const heroVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut',
      },
    },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  return (
    <div className='min-h-svh bg-gray-50'>
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrollY > 50
            ? 'bg-black/30 backdrop-blur-md shadow-lg'
            : 'bg-transparent'
        }`}
      >
        <div className='max-w-7xl mx-auto px-4 sm:px-10 lg:px-8'>
          <div className='flex items-center justify-between h-20'>
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              className='flex items-center space-x-3 p-1'
            >
              <div className='relative'>
                <img
                  src={logo}
                  alt='Hermínio Rodrigues - Logótipo'
                  className='relative z-10 w-full max-w-md lg:max-w-lg h-auto p-4'
                />
              </div>
            </motion.div>

            <div className='hidden md:flex items-center space-x-8'>
              <Link
                to='/candidatos'
                className='text-gray-700 md:text-white hover:text-orange-600 md:hover:text-gray-700 transition-colors duration-300 font-medium'
              >
                CANDIDATOS
              </Link>
              <a
                href='#mensagem'
                className='text-gray-700 md:text-white hover:text-orange-600 md:hover:text-gray-700 transition-colors duration-300 font-medium'
              >
                MENSAGEM
              </a>
              <a
                href='https://linktr.ee/SEMPRECONSIGO'
                className='text-gray-700 md:text-white hover:text-orange-600 md:hover:text-gray-700 transition-colors duration-300 font-medium'
              >
                PROGRAMAS
              </a>
              <a
                href='#contactos'
                className='text-gray-700 md:text-white hover:text-orange-600 md:hover:text-gray-700 transition-colors duration-300 font-medium'
              >
                CONTACTOS
              </a>
              <a
                href={marianaLink}
                target='_blank'
                className='block text-gray-700 md:text-white hover:text-orange-600 md:hover:text-gray-700 transition-colors duration-300 font-medium border border-white p-2 rounded-lg hover:bg-white'
              >
                PERGUNTA À MARIANA
              </a>
            </div>

            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className='md:hidden p-2 rounded-lg hover:bg-orange-100 border border-white transition-colors duration-300 group'
            >
              <div className='w-6 h-6 flex flex-col justify-center'>
                <span
                  className={`w-full h-0.5 bg-white group-hover:bg-orange-600 transition-all duration-300 ${
                    isMenuOpen ? 'rotate-45 translate-y-[0.375rem]' : ''
                  }`}
                ></span>
                <span
                  className={`w-full h-0.5 bg-white group-hover:bg-orange-600 mt-1 transition-all duration-300 ${
                    isMenuOpen ? 'opacity-0' : ''
                  }`}
                ></span>
                <span
                  className={`w-full h-0.5 bg-white group-hover:bg-orange-600 mt-1 transition-all duration-300 ${
                    isMenuOpen ? '-rotate-45 -translate-y-[0.375rem]' : ''
                  }`}
                ></span>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden transition-all duration-300 ease-in-out ${
            isMenuOpen ? 'block' : 'hidden'
          }`}
        >
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className='bg-white/95 backdrop-blur-md border-t border-gray-200'
          >
            <div className='px-4 py-4 space-y-4'>
              <Link
                to='/candidatos'
                className='block text-gray-700 md:text-white hover:text-orange-600 md:hover:text-gray-700 transition-colors duration-300 font-medium'
                onClick={() => setIsMenuOpen(false)}
              >
                CANDIDATOS
              </Link>
              <a
                href='#mensagem'
                className='block text-gray-700 md:text-white hover:text-orange-600 md:hover:text-gray-700 transition-colors duration-300 font-medium'
                onClick={() => setIsMenuOpen(false)}
              >
                MENSAGEM
              </a>
              <a
                href='https://linktr.ee/SEMPRECONSIGO'
                className='block text-gray-700 md:text-white hover:text-orange-600 md:hover:text-gray-700 transition-colors duration-300 font-medium'
                onClick={() => setIsMenuOpen(false)}
              >
                PROGRAMAS
              </a>
              <a
                href='#contactos'
                className='block text-gray-700 md:text-white hover:text-orange-600 md:hover:text-gray-700 transition-colors duration-300 font-medium'
                onClick={() => setIsMenuOpen(false)}
              >
                CONTACTOS
              </a>
              <a
                href={marianaLink}
                target='_blank'
                className='block text-white bg-orange-600 md:text-white hover:text-orange-600 md:hover:text-gray-700 transition-colors duration-300 font-medium  border border-white p-2 rounded-lg hover:bg-white'
                onClick={() => setIsMenuOpen(false)}
              >
                PERGUNTA À MARIANA
              </a>
            </div>
          </motion.div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className='relative min-h-screen flex items-center justify-center overflow-hidden py-20'>
        {/* Background Pattern */}
        <div className='absolute inset-0 bg-gradient-to-br from-orange-400 via-orange-500 to-orange-600'>
          <div className='absolute inset-0 bg-black/10'></div>
          <div
            className='absolute inset-0 opacity-20'
            style={{
              backgroundImage: `url("./assets/fundo.jpg")`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          ></div>
        </div>

        <div className='relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
          <div className='grid grid-cols-1 lg:grid-cols-2 gap-12 place-items-center'>
            {/* Left Side - Content */}
            <motion.div
              variants={heroVariants}
              initial='hidden'
              animate='visible'
              className='text-center lg:text-right'
            >
              <motion.h1
                variants={itemVariants}
                className='text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight'
              >
                Sempre consigo.
              </motion.h1>
              <motion.h2
                variants={itemVariants}
                className='text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light text-white mb-8 leading-tight'
              >
                Sempre pelo Concelho de Alcobaça.
              </motion.h2>
            </motion.div>

            {/* Right Side - Candidate Image  h-auto  */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              className='flex justify-center lg:justify-end place-items-end place-content-end'
            >
              <div className='relative'>
                <img
                  src={fotocandidato}
                  alt='Hermínio Rodrigues - Candidato a Presidente da Câmara Municipal de Alcobaça'
                  className='relative z-10 w-60 sm:w-64 md:w-80 lg:w-96 xl:w-full max-w-lg'
                />
              </div>
            </motion.div>

            {/* 


            <div className="bg-black w-96" >01</div>
            <div className="bg-white w-96" >02</div>
            
            */}
          </div>
        </div>

        {/* Scroll Indicator */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1 }}
          className='absolute bottom-8 left-1/2 transform -translate-x-1/2'
        >
          <div className='flex flex-col items-center space-y-2'>
            <span className='text-white/80 text-sm'>Scroll</span>
            <div className='w-6 h-10 border-2 border-white/60 rounded-full flex justify-center'>
              <div className='w-1 h-3 bg-white/60 rounded-full mt-2 animate-bounce'></div>
            </div>
          </div>
        </motion.div>
      </section>

      {/* Campaign Description Section */}
      <section id='mensagem' className='py-20 bg-white'>
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
          <motion.div
            variants={staggerContainer}
            initial='hidden'
            whileInView='visible'
            viewport={{ once: true, amount: 0.3 }}
            className='text-center mb-16'
          >
            <motion.h2
              variants={itemVariants}
              className='text-3xl md:text-4xl font-bold text-gray-900 mb-6'
            >
              Estive. Estou. E estarei.
              <br />{' '}
              <span className='text-orange-500'>
                {' '}
                Sempre aqui. Sempre pelo Concelho de Alcobaça.
              </span>
            </motion.h2>
            <motion.div
              variants={itemVariants}
              className='w-24 h-1 bg-orange-600 mx-auto mb-8'
            ></motion.div>
          </motion.div>

          <motion.div
            variants={staggerContainer}
            initial='hidden'
            whileInView='visible'
            viewport={{ once: true, amount: 0.3 }}
            className='grid grid-cols-1 md:grid-cols-2 gap-12 items-center'
          >
            <motion.div variants={itemVariants} className='space-y-6'>
              <p className='text-lg text-gray-600 leading-relaxed text-justify'>
                Conheça a equipa que com dedicação, competência e proximidade,
                estará sempre consigo ao serviço do concelho de Alcobaça!
              </p>
              <p className='text-lg text-gray-600 leading-relaxed text-justify'>
                Liderada por Hermínio Rodrigues, candidato à presidência da
                Câmara Municipal, esta equipa reúne pessoas experientes e
                dinâmicas, empenhadas em dar continuidade ao trabalho
                desenvolvido nos últimos anos e em impulsionar ainda mais o
                crescimento sustentável e inclusivo do nosso concelho.
              </p>
            </motion.div>

            <motion.div variants={itemVariants} className='space-y-6'>
              <p className='text-lg text-gray-600 leading-relaxed text-justify'>
                Uma equipa comprometida com Alcobaça, sempre consigo, pronta
                para continuar a trabalhar com rigor, transparência e
                responsabilidade, ouvindo sempre as pessoas e valorizando cada
                freguesia.
                <br />
                <br />
                Contamos consigo para juntos construirmos o futuro do nosso
                concelho!
                <br />
                <br /> <b>Sempre consigo!</b>
              </p>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Video Section */}
      <section className='py-20 bg-white'>
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
          <motion.div
            variants={staggerContainer}
            initial='hidden'
            whileInView='visible'
            viewport={{ once: true, amount: 0.3 }}
            className='text-center mb-16'
          >
            <motion.h2
              variants={itemVariants}
              className='text-4xl md:text-5xl font-bold text-gray-900 mb-6'
            >
              <span className='text-orange-600'>Veja o </span>Nosso Vídeo
            </motion.h2>
            <motion.div
              variants={itemVariants}
              className='w-24 h-1 bg-orange-600 mx-auto mb-8'
            ></motion.div>
          </motion.div>

          <motion.div
            variants={itemVariants}
            initial='hidden'
            whileInView='visible'
            viewport={{ once: true, amount: 0.3 }}
            className='relative max-w-4xl mx-auto'
          >
            <div className='relative bg-gradient-to-r from-orange-500 to-orange-600 p-2 rounded-3xl shadow-2xl'>
              <div className='relative pb-[56.25%] h-0 overflow-hidden rounded-2xl bg-black'>
                <iframe
                  className='absolute top-0 left-0 w-full h-full'
                  src='https://www.youtube.com/embed/862FS7mYruQ?si=rvXGeKrEEbJvvISS'
                  title='YouTube video player'
                  frameborder='0'
                  allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                  referrerpolicy='strict-origin-when-cross-origin'
                  allowfullscreen
                ></iframe>
                {/* 
                <iframe
                  className="absolute top-0 left-0 w-full h-full"
                  src="https://youtu.be/862FS7mYruQ?rel=0&modestbranding=1&showinfo=0&controls=1"
                  title="Jorge Vala 2025 - Campanha Política Porto de Mós"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
                */}
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Town Image Section */}
      <section className='relative py-20 overflow-hidden'>
        <div className='absolute inset-0'>
          <img
            src={fotoaerea}
            alt='Porto de Mós - Vista Aérea'
            className='w-full h-full object-cover'
          />
          <div className='absolute inset-0 bg-gradient-to-t from-orange-600/90 via-orange-500/60 to-transparent'></div>
        </div>

        <div className='relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
          <div className='flex items-end justify-center min-h-96'>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className='text-center text-white'
            >
              <div className='bg-white/10 backdrop-blur-md rounded-3xl p-8 shadow-3xl'>
                <h3 className='text-3xl md:text-4xl font-bold mb-4'>
                  Sempre consigo.
                </h3>
                <p className='text-xl md:text-2xl text-white/90 max-w-2xl mx-auto'>
                  Sempre pelo Concelho de Alcobaça.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      {/* 
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              <span className="text-orange-600">Mensagens de Apoio</span>
            </h2>
            <div className="w-24 h-1 bg-orange-600 mx-auto"></div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={30}
              slidesPerView={1}
              slidesPerGroup={1}
              navigation
              pagination={{ clickable: true, dynamicBullets: true }}
              autoplay={{ delay: 5000 }}
              loop={true}
              breakpoints={{
                768: {
                  slidesPerView: 2,
                  slidesPerGroup: 1,
                },
                1024: {
                  slidesPerView: 2,
                  slidesPerGroup: 1,
                },
              }}
              className="testimonials-swiper"
            >
              {testimonials.map((testimonial, index) => (
                <SwiperSlide key={index}>
                  <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
                    <div className="flex items-center mb-6">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="w-16 h-16 rounded-full object-cover mr-4"
                      />
                      <div>
                        <h4 className="text-xl font-bold text-gray-900">{testimonial.name}</h4>
                        <p className="text-orange-600 font-medium">{testimonial.role}</p>
                      </div>
                    </div>
                    <p className="text-gray-600 leading-relaxed italic">
                      "{testimonial.content}"
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </motion.div>
        </div>
      </section>
      */}

      {/* Footer */}
      <footer id='contactos' className='bg-orange-600 text-white py-16'>
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12'>
            {/* Brand Section */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className='flex items-center space-x-3 mb-6'>
                <div className='relative'>
                  <img
                    src={logo}
                    alt='Hermínio Rodrigues - Logótipo'
                    className='relative z-10 w-full max-w-md lg:max-w-lg h-auto'
                  />
                </div>
              </div>
              <div className='flex space-x-4'>
                <p className='text-white/80 text-lg mb-6 text-justify'>
                  <span className='font-bold'>Sempre consigo.</span> <br />
                  Sempre pelo Concelho de Alcobaça.
                </p>
              </div>
              <div className='flex space-x-4'>
                <a
                  href='https://www.facebook.com/AquiConsigo21/'
                  className='text-white hover:text-orange-200 transition-colors duration-300'
                >
                  <FaFacebook size={40} />
                </a>
                <a
                  href='https://www.instagram.com/aquiconsigo2021/'
                  className='text-white hover:text-orange-200 transition-colors duration-300'
                >
                  <FaInstagram size={40} />
                </a>
              </div>
            </motion.div>

            {/* Contact Info */}
            {/*
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <h3 className="text-2xl font-bold mb-6">Contactos</h3>
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <FaEnvelope className="text-orange-200" />
                  <span className="text-white/90">geral@sempreconsigo.pt</span>
                </div>
              </div>
            </motion.div>
            */}

            {/* Newsletter */}
            {/* 
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <h3 className="text-2xl font-bold mb-6">Mantenha-se Informado</h3>
              <p className="text-white/80 mb-6">
                Receba as últimas notícias e atualizações da nossa campanha.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  placeholder="Seu email"
                  className="flex-1 px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-white/50"
                />
                <button className="bg-white text-orange-600 px-6 py-3 rounded-lg font-bold hover:bg-orange-50 transition-colors duration-300">
                  Subscrever
                </button>
              </div>
            </motion.div>
            */}
          </div>

          <div className='mt-12 pt-8 border-t border-white/20 text-center'>
            <p className='text-white/80'>
              ©2025 PSD Alcobaça - Todos os direitos reservados.{' '}
              <a href='mailto:geral@sempreconsigo.pt?subject=Sempre Consigo'>
                geral@sempreconsigo.pt
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
